import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined";

type Props = {
    titulo: string;
    descricao: string;
    /**
     * Se true, o alerta sempre aparece.
     * Se omitido, o alerta só aparece se location.state.showSuccessAlert for true.
     */
    forceShow?: boolean;
};

export default function TenMinutesAlert({ descricao, titulo, forceShow }: Props) {
    const location = useLocation<{ showSuccessAlert?: boolean }>();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (forceShow) {
            setOpen(true);
            return;
        }
        if (location.state?.showSuccessAlert) {
            setOpen(true);
            // Limpa o state para evitar mostrar novamente ao navegar
            window.history.replaceState({}, document.title);
        }
    }, [location.state, forceShow]);

    if (!open) return null;

    return (
        <Box mb={2}>
            <Paper
                elevation={3}
                style={{
                    background: "#eef6f0",
                    padding: 16,
                    display: "flex",
                    alignItems: "flex-start",
                    position: "relative",
                }}
            >
                <CheckCircleOutlined style={{ color: "#388e3c", marginRight: 12, marginTop: 2 }} />
                <Box flex={1} maxWidth="80%">
                    <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#1b4332" }}>
                        {titulo || "Atenção!"}
                    </Typography>
                    <Typography variant="body2" style={{ color: "#1b4332" }}>
                        {descricao || ""}
                    </Typography>
                </Box>
                <IconButton
                    aria-label="fechar"
                    size="small"
                    onClick={() => setOpen(false)}
                    disableRipple
                    disableFocusRipple
                    style={{
                        color: "#1b4332",
                        position: "absolute",
                        top: 10,
                        right: 10,
                        fontSize: 16,
                        background: "none"
                    }}
                    onMouseOver={e => (e.currentTarget.style.background = "none")}
                    onMouseOut={e => (e.currentTarget.style.background = "none")}
                    onFocus={e => (e.currentTarget.style.background = "none")}
                >
                    FECHAR
                </IconButton>
            </Paper>
        </Box>
    );
}